import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import Spacer from '../Spacer';
import TranslationProvider from '../../providers/TranslationProvider';
import CloseShift from '../../svg/icons/closeshift.svg';
import './MaintenancePage.scss';

const getMaintenanceRestoreTime = (maintenance) => {
  const { endTime, endDate } = maintenance ?? {};
  if (endTime && endDate) {
    return `${endTime} on ${endDate}`;
  }
  return null;
};

const MaintenancePage = (props) => {
  const {
    Analytics,
    maintenance,
  } = props;

  const restoreTime = getMaintenanceRestoreTime(maintenance);

  // The page replaces the whole app, so it re-renders as often as its host does.
  // Track the event once per mount to keep the analytics count honest.
  const hasTracked = useRef(false);
  if (!hasTracked.current) {
    hasTracked.current = true;
    Analytics?.event('500', {
      category: 'Maintenance',
      label: `${window.location.pathname}${window.location.search}`,
    });
  }

  return (
    <div className="MaintenancePageContainer">
      <Icon
        name="Maintenance"
        component={CloseShift}
        width="3em"
        height="3em"
      />
      <Spacer height={50} />
      <TranslationProvider translationKey="maintenance_heading">
        <h1>Resy is currently undergoing scheduled maintenance.</h1>
      </TranslationProvider>
      {restoreTime
        ? (
          <TranslationProvider
            translationKey="maintenance_body_with_restore_time"
            translationValues={{ restoreTime }}
          >
            <p>{`As part of planned platform improvements, service is expected to be fully restored by <strong>${restoreTime}</strong>.`}</p>
          </TranslationProvider>
        )
        : (
          <TranslationProvider translationKey="maintenance_body_no_restore_time">
            <p>As part of planned platform improvements, service is expected to be fully restored soon.</p>
          </TranslationProvider>
        )}
    </div>
  );
};

MaintenancePage.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }),
  maintenance: PropTypes.shape({
    endTime: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

MaintenancePage.defaultProps = {
  Analytics: null,
  maintenance: null,
};

MaintenancePage.displayName = 'MaintenancePage';

export default MaintenancePage;
